<template>
  <div class="h-100 position-relative">
    <Header
      @flagChange="handleFlagChange"
      :flagList="flagList"
      :currentFlag="currentFlag"
    >
      <template #header-right>
        <div id="product-news"></div>
      </template>
    </Header>
    <slot />
    <Footer
      :countryCode="currentFlag ? currentFlag.countryCode.toLowerCase() : undefined" />

    <DialogConfirmChangedCountry
      :isOpen="isSwitchCountryModal"
      :closeOnClickOutside="false"
      @discard="handleDiscardChangedCountry"
      @confirm="handleConfirmChangedCountry"
    />

    <DialogSwitchToMobile
      :isOpen="isShowSwitchToMobileDialog"
      :closeOnClickOutside="false"
      @discard="handleDiscardSwitchToMobile"
      @confirm="handleConfirmSwitchToMobile"
    />
  </div>
</template>

<script>
import { FLAG_LIST_DEFAULT } from '@/utils/constants.js'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import DialogConfirmChangedCountry from '@/components/dialog/DialogConfirmChangedCountry.vue'
import DialogSwitchToMobile from '@/components/dialog/DialogSwitchToMobile.vue'
import { mapGetters, mapActions } from 'vuex'
import { getRedirectionUrlByWindowLocation } from '@/utils/location'
import isMobile from 'is-mobile'

export default {
  components: {
    Header,
    Footer,
    DialogConfirmChangedCountry,
    DialogSwitchToMobile
  },

  props: {
    hasChangedData: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      flagList: FLAG_LIST_DEFAULT,
      currentFlag: undefined,
      changingCountry: undefined,
      isShowSwitchToMobileDialog: false
    }
  },

  computed: {
    ...mapGetters({
      country: 'settings/country',
      isSwitchCountryModal: 'settings/getSwitchCountryModalStatus',
      mobileSettingForCurrentCountry: 'settings/getSettingMobileSupportedCurrentCountry'
    }),
    currentCountryCode () {
      const countryCode = this.extractCountryCodeFromLocation()
      const currentCountryCode = this.$route.params.countryCode ? this.$route.params.countryCode.toUpperCase() : countryCode
      console.info('Current country code', currentCountryCode)
      return currentCountryCode
    }
  },

  watch: {
    country: {
      handler () {
        if (!this.country) {
          return
        }

        const flagItem = this.flagList.filter(item => item.countryCode === this.country.code)[0]
        if (!flagItem) {
          this.currentFlag = this.flagList[0]
        } else {
          this.currentFlag = flagItem
        }
      },
      immediate: true
    },
    '$route.params.countryCode': {
      handler (newValue) {
        if (!!this.country && (newValue.toUpperCase() !== this.country.code.toUpperCase())) {
          this.updateSettings({ countryCode: newValue.toUpperCase() })
        }
      }
    },
    mobileSettingForCurrentCountry (newSettings) {
      if (isMobile() && newSettings?.enabled === true) {
        this.isShowSwitchToMobileDialog = true
      }
    }
  },
  mounted () {
    // noinspection JSUnresolvedReference
    window.__EP_SDK__ &&
    window.__EP_SDK__.globalBus &&
    window.__EP_SDK__.globalBus.publish('layout:ready',
      {
        countryCode: this.currentCountryCode
      }
    )
  },

  beforeDestroy () {
    // noinspection JSUnresolvedReference
    window.__EP_SDK__ &&
    window.__EP_SDK__.globalBus &&
    window.__EP_SDK__.globalBus.publish('layout:destroy',
      {
        countryCode: this.currentCountryCode
      }
    )
  },

  methods: {
    ...mapActions({
      updateSettings: 'settings/updateSettings',
      toggleSwitchCountryModal: 'settings/toggleSwitchCountryModal'
    }),

    extractCountryCodeFromLocation () {
      const url = window.location.href
      const regex = /\/([a-z]{2})\//i
      const match = url.match(regex)
      return match ? match[1].toUpperCase() : null
    },

    handleFlagChange (flagCode) {
      if (flagCode === this.currentCountryCode) {
        return
      }

      this.changingCountry = flagCode

      if (this.hasChangedData) {
        this.showChangeCountryDialog()
      } else {
        this.handleConfirmChangedCountry()
      }
    },

    handleDiscardChangedCountry () {
      this.hideChangeCountryDialog()
    },

    async handleConfirmChangedCountry () {
      this.$emit('confirmChangeFlag')
      const countryCode = this.changingCountry.toLowerCase()
      const url = getRedirectionUrlByWindowLocation(countryCode)
      window.location = url
    },

    showChangeCountryDialog () {
      this.toggleSwitchCountryModal()
    },

    hideChangeCountryDialog () {
      this.toggleSwitchCountryModal()
    },

    handleDiscardSwitchToMobile () {
      this.isShowSwitchToMobileDialog = false
    },

    handleConfirmSwitchToMobile () {
      this.isShowSwitchToMobileDialog = false

      window.location.href = this.mobileSettingForCurrentCountry?.redirectUrl
    }
  }
}
</script>
